/**
 * Returns an E.164 standard compliant phone number prepended with a '+'
 * See: https://en.wikipedia.org/wiki/E.123
 */
var getInternationalNumber = function getInternationalNumber(phoneNumber) {
  return !phoneNumber || !phoneNumber[0] || phoneNumber[0] !== '+' ? "+".concat(phoneNumber) : phoneNumber;
};

export { getInternationalNumber };
